export default {
  SalarySlip: 'Phiếu chi trả lương',
  PayDepositPayment: 'Chi tiền gửi trả lương',
  VoucherFromSalaGov: 'Lấy chứng từ tại SalaGov',
};
